import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ModalService } from '@common/services/modal.service';
import { DataService, PaymentRecord, PaymentType, PaymentState } from '@core/services/data.service';
import { NumberInputComponent } from '@common/UI/number-input/number-input.component';
import { CalendarComponent } from '@common/UI/calendar/calendar.component';

@Component({
  selector: 'app-provider-payment-editor',
  templateUrl: './provider-payment-editor.component.html',
  styleUrls: ['./provider-payment-editor.component.scss']
})
export class ProviderPaymentEditorComponent implements OnInit {

  constructor(private modal: ModalService, private ds: DataService) { }

  ngOnInit(): void {
  }

  @Output()
  public create = new EventEmitter<PaymentRecord>();

  public payment: PaymentRecord = {
    ID: 0,
    PartnerID: 1,
    Type: PaymentType.Expense | PaymentType.Partner,
    State: PaymentState.Confirmed,
    SendAmount: 0,
    SendSymbol: "VND",
    ReceiveAmount: 0,
    ReceiveSymbol: "CNY",
    Notes: '',
    CreatorID: 0,
    UpdatorID: 0,
    FirstStamp: 0,
    LastStamp: 0,
    Stamp: new Date().getTime()
  };

  public close() {
    this.modal.of(this).hide();
  }

  public update(editor: NumberInputComponent, type: 'SendAmount' | 'ReceiveAmount') {
    if (isNaN(editor.value)) editor.value = 0;

    this.payment[type] = editor.value;
  }

  public editStamp() {
    let ref = this.modal.show(CalendarComponent, { state: { selected: new Date(this.payment.Stamp) }, ignoreBackdropClick: true });

    ref.content.change.subscribe(date => {
      this.payment.Stamp = date.getTime();
      ref.hide();
    });
  }

  public get savable(): boolean {
    return this.payment.SendAmount > 0 && this.payment.ReceiveAmount > 0;
  }

  public get saving(): boolean {
    return !this.modal.of(this).closable;
  }

  public save() {

    this.modal.of(this).closable = false;  

    if (this.payment.SendAmount > 0 && this.payment.ReceiveAmount > 0) {
      this.ds.payments('create', this.payment).subscribe(payments => {
        if (payments && payments.length == 1) {
          this.create.emit(payments[0]);
          this.close();
        }

        this.modal.of(this).closable = true;  
      });
    }
  }
  
}
